import React, { useState } from 'react';
import { collectTask } from '../Services/masterService';
import Modal from '../AlertModal/Modal';

const TaskCollectionModal = ({ isOpen, onClose, taskData, onSubmit }) => {
    const [description, setDescription] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]); // This will now accumulate files
    const [isSubmitting, setIsSubmitting] = useState(false);

    /**
     * Handles file selection. Merges newly selected files with existing ones,
     * preventing duplicates based on file name.
     */

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newlySelectedFiles = Array.from(e.target.files);

            setSelectedFiles(prevFiles => {
                // Create a Set of existing file names for quick lookup
                const existingFileNames = new Set(prevFiles.map(f => f.name));

                // Filter out any newly selected files that are already in the list
                const uniqueNewFiles = newlySelectedFiles.filter(
                    newFile => !existingFileNames.has(newFile.name)
                );

                // Return the merged array of old files and unique new files
                return [...prevFiles, ...uniqueNewFiles];
            });
        }
    };

    // Function to remove a specific file from the list
    const removeFile = (fileNameToRemove) => {
        setSelectedFiles(prevFiles => prevFiles.filter(file => file.name !== fileNameToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if at least one file is selected
        if (selectedFiles.length === 0) {
            showError("Oops!","Please upload at least one image.");
            return;
        }

        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('taskId', taskData.id);
        formData.append('description', description);

        // Append selected files
        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append('files', selectedFiles[i]);
        }

        try {
            const result = await collectTask(formData);

            if (result.status == 1) {
                showSuccess("Collected Successfully!");
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                showError("Failed to collect Sample!");
            }
        } catch (error) {
            console.error("Submission failed in modal:", error);
            showError("An error occurred while submitting.");
        } finally {
            setIsSubmitting(false);
        }
    };


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);
    //     const formData = new FormData();
    //     formData.append('taskId', taskData.id);
    //     formData.append('description', description);
    //     for (let i = 0; i < selectedFiles.length; i++) {
    //         formData.append('files', selectedFiles[i]);
    //     }

    //     setIsSubmitting(false);
    //     const result = await collectTask(formData);
    //     if (result.status == 1) {
    //         showSuccess("Collected Successfully!")
    //         setTimeout(() => {
    //             window.location.reload();
    //         }, 1000);
    //     } else {
    //         showError("Failed to collect Sample!");
    //     }
    //     return
    //     try {
    //         await onSubmit(formData);
    //     } catch (error) {
    //         console.error("Submission failed in modal:", error);
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg">
                <div className="bg-gradient-to-r from-emerald-600 to-green-600 p-5 flex justify-between items-center rounded-t-xl">
                    <h2 className="text-xl font-bold text-white">Submit Task Collection</h2>
                    <button onClick={onClose} disabled={isSubmitting} className="text-white hover:text-green-200 text-2xl">&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="p-6 space-y-6">
                        {/* Description Textarea */}
                        <div>
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <textarea
                                id="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows="4"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                                placeholder="Add comments about the task completion..."
                                required
                            />
                        </div>

                        {/* File Upload Section */}
                        <div>
                            <label htmlFor="files" className="block text-sm font-medium text-gray-700 mb-1">Upload Files (Multiple)</label>
                            <input
                                type="file"
                                id="files"
                                multiple
                                onChange={handleFileChange}
                                className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
                            />
                        </div>

                        {selectedFiles.length > 0 && (
                            <div className="border-t pt-4">
                                <h4 className="text-sm font-medium text-gray-600 mb-2">Selected Files:</h4>
                                <ul className="space-y-2 text-sm text-gray-700">
                                    {selectedFiles.map((file, index) => (
                                        <li key={index} className="flex justify-between items-center bg-gray-50 p-2 rounded-md">
                                            <span>{file.name}</span>
                                            <button
                                                type="button"
                                                onClick={() => removeFile(file.name)}
                                                className="text-red-500 hover:text-red-700 font-bold text-lg"
                                            >
                                                &times;
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    {/* Modal Footer */}
                    <div className="bg-gray-50 p-4 flex justify-end space-x-4 rounded-b-xl">
                        <button type="button" onClick={onClose} disabled={isSubmitting} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition-colors disabled:opacity-50">
                            Cancel
                        </button>
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:bg-green-400">
                            {isSubmitting ? 'Submitting...' : 'Submit Collection'}
                        </button>
                    </div>
                </form>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
            />
        </div>
    );
};

export default TaskCollectionModal;

